import { InMemoryCache } from '@apollo/client/cache'

import fragmentMatcher from './fragmentMatcher'

const cache = new InMemoryCache({
  fragmentMatcher,
  typePolicies: {
    Account: {
      fields: {
        signature: {
          // This field is a dynamic field that can change, which causes the entire cache to be invalidated.
          merge(existing, _incoming) {
            return existing ?? null
          }
        }
      }
    }
  }
})

export default cache
